import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

const SeverityPillRoot = styled("span")(({ ownerState }) => {
  const wtheme = useTheme();
  const backgroundColor = wtheme.palette[ownerState.color].main;
  const color = wtheme.palette[ownerState.color].contrastText;

  return {
    alignItems: "center",
    backgroundColor,
    borderRadius: 12,
    color,
    cursor: "default",
    display: "inline-flex",
    flexGrow: 0,
    flexShrink: 0,
    // fontFamily: theme.typography.fontFamily,
    // fontSize: theme.typography.pxToRem(10),
    fontSize: "14px",
    lineHeight: 2,
    // fontWeight: 800,
    fontWeight: 600,
    justifyContent: "center",
    letterSpacing: 0.2,
    minWidth: 20,
    paddingLeft: wtheme.spacing(1),
    paddingRight: wtheme.spacing(1),
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  };
});

export const SeverityPill = (props) => {
  const { color, children } = props;
  const ownerState = { color };
  return (
    <SeverityPillRoot ownerState={ownerState}>{children}</SeverityPillRoot>
  );
};

SeverityPill.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "info",
    "warning",
    "success",
    "ready",
    "acw",
    "aux",
    "busy",
    "not bound",
    "loggedoff",
    "offline",
  ]),
};
